'use client';

import '../app/styles/404_err_page.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';

import Header from "../app/components/header";
import Footer from "../app/components/footer";
import LeftSideSocialButtons from '../app/components/LeftSideSocialButtons';
import Link from 'next/link';
import Image from 'next/image';

export default function NotFound() {
    return (
        <div>
            <Header />
        <div className="container-fluid">
        <div className="row d-flex justify-content-center align-items-center height-vh">
        <div className="err-img">
            <Image src="/404_err.png" alt="404-error-image" width={400} height={371}/>
        </div>
        </div>
        </div>

        <div className="container-fluid-2">
        <div className="err-msg-solution">
        <div className="err-msg-solution d-flex flex-column justify-content-center align-items-center">
            <h2> We Couldn&apos;t Find This Page. </h2>
            <div className="text-center mt-4 mb-5">
            <Link href="/">
                <button className="btn px-3 mr-2"><i className="fa fa-home"></i> Home</button>
            </Link>
            <Link href="/contact-us">
            <button className="btn px-3 mr-2"><i className="fa fa-phone"></i> Contact</button>
            </Link>
            </div>       
        </div>
        </div>
        </div>
        <LeftSideSocialButtons />
      <Footer />
        </div>

);
}